<template>
  <el-select v-model="value" placeholder="请选择" @change="changeValue($event)" clearable >
    <el-option
      v-for="item in staffs"
      :key="item.code"
      :label="item.name"
      :value="item.code"
    />
  </el-select>
</template>
<script>
  import request from '@/utils/request'
  export default {
    data() {
      return {
        value: '',
        staffs: [],
        callbackMethod: ''
      }
    },
    created() {
      this.findStaffs()
    },
    methods: {
      findStaffs() {
        request({
          url: '/ntocc-basic-api/staffs/notHaveUserLoginStafflist',
          method: 'get',
          params: {  partyType: 'STAFF' }
        }).then(response => {
          this.staffs = response.data
        })
      },
      changeValue(e) {
        this.$emit("setStaffCode", this.value)
      },
      setSelectValue(value) {
        this.value = value
      },
      initDict(staffs, callbackMethod) {
        this.staffs = staffs
        this.callbackMethod = callbackMethod
      }
    }
  }
</script>

